import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { DEPRECATED } from '@zocdoc-mezzanine/foundations-colors';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

import { EMERGENCY_NOTICE_STRINGS } from './constants';

const BaseEmergencyNotice = ({ showEmergencyNotice }) => {
    if (!showEmergencyNotice) return null;

    return (
        <EmergencyNotice data-test="emergency-notice">
            {EMERGENCY_NOTICE_STRINGS.Call911}
        </EmergencyNotice>
    );
};

BaseEmergencyNotice.propTypes = {
    showEmergencyNotice: PropTypes.bool,
};

const EmergencyNotice = styled.div`
    background-color: #ffecf1;
    border: solid 1px ${DEPRECATED.tertiaryCoral};
    font: 15px/24px ${FontFamily.SharpSansMedium};
    margin-top: 8px;
    padding: 8px 16px;
`;

export default BaseEmergencyNotice;
